"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "taranto": {
    "ad62663f": [{
      "hkey": "47488032",
      "slug": "citta-vecchia-isola",
      "name": "Città Vecchia-Isola",
      "primary": true,
      "skipSearch": false
    }],
    "isola-porta-napoli": [{
      "hkey": "47488032",
      "slug": "citta-vecchia-isola",
      "name": "Città Vecchia-Isola",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "2d855f1b": [{
      "hkey": "eced40cb",
      "slug": "carelli-lama-san-vito",
      "name": "Carelli-Lama-San Vito",
      "primary": true,
      "skipSearch": false
    }],
    "s-vito-lama-carelli": [{
      "hkey": "eced40cb",
      "slug": "carelli-lama-san-vito",
      "name": "Carelli-Lama-San Vito",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "5ebcef42": [{
      "hkey": "2dac082f",
      "slug": "corvisea-solito",
      "name": "Corvisea-Solito",
      "primary": true,
      "skipSearch": false
    }],
    "solito-corvisea": [{
      "hkey": "2dac082f",
      "slug": "corvisea-solito",
      "name": "Corvisea-Solito",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "b4075b8f": [{
      "hkey": "257989dd",
      "slug": "talsano",
      "name": "Talsano",
      "primary": true,
      "skipSearch": false
    }],
    "talsano-s-donato": [{
      "hkey": "257989dd",
      "slug": "talsano",
      "name": "Talsano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "1d01c166": [{
      "hkey": "71c1cba8",
      "slug": "tamburi",
      "name": "Tamburi",
      "primary": true,
      "skipSearch": false
    }],
    "tamburi-croce": [{
      "hkey": "71c1cba8",
      "slug": "tamburi",
      "name": "Tamburi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "59c74be0": [{
      "hkey": "767d7d7a",
      "slug": "via-cesare-battisti-tre-carrare",
      "name": "Via Cesare Battisti-Tre Carrare",
      "primary": true,
      "skipSearch": false
    }],
    "trecarrare-battisti": [{
      "hkey": "767d7d7a",
      "slug": "via-cesare-battisti-tre-carrare",
      "name": "Via Cesare Battisti-Tre Carrare",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;